/**
 * Opening a record in the right-side panel from anywhere (a list row, a
 * search result, the audit log) without passing props through the page:
 * openRecord({kind, id}) → the shell's RecordDrawerHost shows it.
 * See docs/features/record-history.md.
 */
export type RecordKind = "product" | "count" | "invoice" | "order" | "recipe" | "supplier" | "area";
export const RECORD_KINDS: RecordKind[] = ["product", "count", "invoice", "order", "recipe", "supplier", "area"];
export type RecordRef = { kind: RecordKind; id: string; title?: string; tab?: "details" | "history" };

export const OPEN_RECORD_EVENT = "parlyst:open-record";

export function openRecord(ref: RecordRef) {
  window.dispatchEvent(new CustomEvent<RecordRef>(OPEN_RECORD_EVENT, { detail: ref }));
}
export const isRecordKind = (k: unknown): k is RecordKind => typeof k === "string" && (RECORD_KINDS as string[]).includes(k);

/** The page that holds each kind of record ("Open page"). */
export const RECORD_PAGE: Record<RecordKind, string> = {
  product: "inventory",
  count: "counts",
  invoice: "invoices",
  order: "suppliers",
  recipe: "recipes",
  supplier: "suppliers",
  area: "settings",
};
export const RECORD_NOUN: Record<RecordKind, string> = {
  product: "Product",
  count: "Count",
  invoice: "Invoice",
  order: "Order",
  recipe: "Recipe",
  supplier: "Supplier",
  area: "Area",
};
